import { render } from "./CertsSection.vue?vue&type=template&id=b4ab9c5e&scoped=true"
import script from "./CertsSection.vue?vue&type=script&lang=js"
export * from "./CertsSection.vue?vue&type=script&lang=js"

import "./CertsSection.vue?vue&type=style&index=0&id=b4ab9c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ab9c5e"]])

export default __exports__